<script lang="ts">
	import type { BrandConfig } from '$lib/brand/types';

	interface Props {
		config: BrandConfig;
		className?: string;
		transparent?: boolean;
	}

	let { config, className = '', transparent = false }: Props = $props();
</script>

<div class="page-container {className}" class:transparent={transparent}>
	<div class="content">
		<slot />
	</div>
</div>

<style lang="scss">
	@use "$lib/scss/_mixins.scss" as *;
	@use "$lib/scss/_themes.scss" as *;

	.page-container {
		@include page-container;
	}

	.content {
		@include content-card;
	}

	.page-container.transparent .content {
		background: transparent;
		padding: 0;
		border-radius: 0;
		box-shadow: none;
	}

	/* Typography styles for content */
	.content :global(h1) {
		@include responsive-heading(2rem, 2.5rem);
		color: var(--brand-primary);
		margin-bottom: var(--spacing--element-gap);
		text-align: center;
	}

	.content :global(h2) {
		@include responsive-heading(1.5rem, 1.75rem);
		color: var(--brand-primary);
		margin-bottom: 1rem;
		margin-top: var(--spacing--element-gap);
	}

	.content :global(h3) {
		@include responsive-heading(1.1rem, 1.25rem);
		color: var(--brand-primary);
		margin-bottom: 0.75rem;
		margin-top: 1.5rem;
	}

	.content :global(p) {
		color: var(--color--text, #374151);
		line-height: 1.7;
		margin-bottom: 1rem;
	}

	.content :global(ul) {
		color: var(--color--text, #374151);
		line-height: 1.7;
		margin-bottom: 1rem;
		padding-left: 1.5rem;
	}

	.content :global(li) {
		margin-bottom: 0.5rem;
	}

	.content :global(a) {
		color: var(--brand-primary);
		text-decoration: none;
		border-bottom: 1px solid var(--brand-primary);
		transition: all 0.3s ease;
	}

	.content :global(a:hover) {
		color: var(--color--accent, var(--brand-secondary));
		border-bottom-color: var(--color--accent, var(--brand-secondary));
	}

	.content :global(em) {
		color: var(--color--text-secondary, #64748b);
		font-style: italic;
	}

	.content :global(.error-container) {
		text-align: center;
	}
</style>
